module.exports = __webpack_public_path__ + "img/nt52-02-80-1.prt.2845e07f.jpg";